export default __webpack_public_path__ + "static/media/flag-of-belgium.d82554cb.svg";